import type { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

import type { SignInFailure } from "@/contexts/authentication-context/authentication-context-utils"
import { RootPath } from "@/models/route"

import { Alert, Link } from "@mui/material"

interface SignInFailureAlertProps {
  failure: SignInFailure
}

export const SignInFailureAlert: FC<SignInFailureAlertProps> = ({
  failure,
}) => {
  const { t } = useTranslation()

  switch (failure) {
    case "connectivity":
      return <Alert severity="error">{t("connectivity.description")}</Alert>
    case "server_error":
      return <Alert severity="error">{t("login.serverError")}</Alert>
    case "invalid_credentials":
      return (
        <Alert severity="warning">
          <Trans i18nKey="login.incorrectCredentialsError">
            Text1
            <Link component={RouterLink} to={`/${RootPath.ForgotPassword}`}>
              link
            </Link>
            text2
          </Trans>
        </Alert>
      )
  }
}
